<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read quality control'">
      <template #gated-content>
        <quality-control-card :qualityControl="quality_control" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/quality-control/${quality_control_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="quality_control"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="quality_control"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import QualityControlCard from '@/components/lab/qualitycontrol/QualityControlCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import QualityControlModel from '@/models/lab/QualityControlModel'

export default {
  name: "QualityControlAuditTrail",
  components: {
    PermissionAlertGate,
    QualityControlCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      quality_control: null,
      quality_control_id: this.$route.params.quality_control_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/quality-control/${this.quality_control_id}`,
            title: "View Quality Control",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.quality_control = new QualityControlModel({ id: this.quality_control_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.quality_control.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
